import phoneMask from '@/utils/phoneMask';
export default {
    date: function (value) {
        if (value) {
            return value.substr(0, value.indexOf('T'));
        }
        return '';
    },
    time: function (value) {
        if (value) {
            return value.substr(value.indexOf('T') + 1, 5);
        }
        return '';
    },
    postalCode: function (value) {
        if (value && value.length >= 5) {
            return value.substr(0, 2) + '-' + value.substr(2);
        }
        return '';
    },
    addColons: function (val) {
        return val + ':';
    },
    phone: function (value) {
        if (value == null || !value) {
            return '';
        } else {
            let i = 0;
            const v = value.toString().replace(/\s/g, '');
            const pattern = phoneMask(v);
            return pattern.replace(/#/g, (_) => v[i++]);
        }
    },
    afterComma: function (value) {
        return value + ', ';
    },
    beforeComma: function (value) {
        return ', ' + value;
    },
    persent: function (value) {
        return value + '%';
    },
    beforeSlash: function (value) {
        return '/' + value;
    },
    brackets: function (value) {
        return '(' + value + ')';
    },
    afterSpace: function (value) {
        return value + ' ';
    },
    beforeSpace: function (val) {
        return ' ' + val;
    },
    emptyToNumber: function (value) {
        if (value === '') {
            return 0;
        }
    },
    currency: function (value) {
        return value + ' PLN';
    },
    zloty: function (value) {
        return value + ' zł';
    },
    timeInput: function (value) {
        if (!value) return '';
        value = String(value);
        return value.substr(0, 2) + ':' + value.substr(2);
    },
    emptyToZero: (value) => {
        if (value === '') {
            return 0;
        }
        return value;
    }
};
